import React from "react";
import {connect} from "react-redux";
import { Link} from "react-router-dom";
import logo from "../../images/logos/logo-white.png"
import twitter from "../../images/icons/twitter.svg"
import instagram from "../../images/icons/instagram.svg"
import facebook from "../../images/icons/facebook.svg"
import email from "../../images/icons/email.png"
import phone from "../../images/icons/phone.svg"


class Footer extends React.Component {

    render() {
        if(this.props.footer.loaded === false ){
            return <div/>
        }
        return (
          <footer className="rob-footer">
              <div className="rob-footer__top-row">
                  <div className="container">
                      <div className={"rob-footer__top-left"}>
                          <img src={logo} className="rob-footer__logo" alt={""}/>
                      </div>
                      <div className={"rob-footer__top-right"}>
                          <h3>Interested in joining the AYA Network? <a>Become a member here</a></h3>
                      </div>
                  </div>
              </div>
              <div className="rob-footer__middle-row">
                  <div className="container">

                          <div className={"rob-footer__middle-left"}>
                              <p>Providing resources to support health professionals in providing high quality medical and supportive care to young people.</p>
                          </div>
                          <div className={"rob-footer__middle-middle"}>
                              <ul>
                              {this.props.footer.data.map((name, index) => {
                                  if(name.type === 'external'){
                                      return  <li key={index} className=""><a target="_blank" href={name.url}>{name.title}</a></li>
                                  }
                                    return  <li key={index} className=""><Link to={name.url}>{name.title}</Link></li>
                              }) }
                              </ul>
                          </div>


                          <div className={"rob-footer__middle-right"}>
                              <a href="tel:021337129"  className="">
                                  <div className="icon__container"><img src={phone} alt={""}/></div>
                                  021 337 129
                              </a>
                              <a href="mailto:AYACancer@adhb.govt.nz"   className="">
                                  <div className="icon__container"><img src={email} alt={""}/></div>
                                  AYACancer@adhb.govt.nz
                              </a>
                          </div>

                  </div>
              </div>
              <div className="rob-footer__bottom-row">

                  <div className={"rob-footer__bottom-left"}>
                      Copyright © 2018 AYA Cancer Network. All right reserved.
                  </div>
                  <div className={"rob-footer__bottom-right"}>
                      Find us on Social Media
                      <a href={"https://twitter.com/NZayacancer"} target={"_blank"}><img src={twitter} alt={""}/></a>
                      <a href={"https://www.facebook.com/ayacancernetwork/"} target={"_blank"}><img src={facebook} alt={""}/></a>
                      <a href={"https://www.instagram.com/ayacancernetwork/"} target={"_blank"} ><img src={instagram} alt={""}/></a>
                  </div>
              </div>
          </footer>
        )
    }
}


function mapStateToProps(state) {
    return {
        footer : state.footer
    };
}

export default connect(mapStateToProps, null)(Footer);



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js